import { render, staticRenderFns } from "./ModalWithTabs.vue?vue&type=template&id=20921c8d&scoped=true&"
import script from "./ModalWithTabs.vue?vue&type=script&lang=js&"
export * from "./ModalWithTabs.vue?vue&type=script&lang=js&"
import style0 from "./ModalWithTabs.vue?vue&type=style&index=0&id=20921c8d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20921c8d",
  null
  
)

export default component.exports